import { capitalize } from "@common/helpers/string";
import { ServiceTemplateRecurrenceOccurrenceStatus } from "@common/types/serviceTemplateRecurrenceOccurrence";
import { Picker } from "@design-system/Picker/Picker.lib";
import type { PickerItemData } from "@design-system/Picker/Picker.types";

const STATUS_ITEMS: Array<
    PickerItemData<ServiceTemplateRecurrenceOccurrenceStatus>
> = Object.values(ServiceTemplateRecurrenceOccurrenceStatus).map((status) => ({
    value: status,
    label: capitalize(status),
}));

const renderStatusSummary = (
    statuses: readonly ServiceTemplateRecurrenceOccurrenceStatus[],
) =>
    statuses.length === 1
        ? capitalize(statuses[0])
        : `${statuses.length} statuses`;

interface Props {
    selectedStatuses: ServiceTemplateRecurrenceOccurrenceStatus[];
    onChange: (statuses: ServiceTemplateRecurrenceOccurrenceStatus[]) => void;
}

// Status filter for the "Upcoming occurrences" drawer. Only 3 static options
// (Select is reserved for ≤5 static options with no search), and defaults to
// nothing selected — i.e. no filtering, all statuses shown — rather than
// treating "all selected" as the unfiltered state.
export const ServiceTemplateScheduleOccurrenceStatusFilter = ({
    selectedStatuses,
    onChange,
}: Props) => (
    <Picker.Select
        multiple
        items={STATUS_ITEMS}
        value={selectedStatuses}
        onValueChange={onChange}
        placeholder="All statuses"
        renderValue={renderStatusSummary}
    />
);
